<div>
    <p-toast></p-toast>

    <hr class="hr-filter"/>

    <p-scrollPanel [style]="{height: 'calc(100vh - 160px)'}">
        <div class="mg-side10">
            <div class="flex justify-content-between filter-title-block">
                <span class="filter-title">Rider</span>
            </div>
            <div>
                <p-dropdown [options]="riders" [(ngModel)]="riderId" optionLabel="FullName" optionValue="Id" [filter]="true" filterBy="FullName" [showClear]="true" placeholder="Select a rider">
                    <ng-template let-rider pTemplate="item">
                        <div>{{rider.FullName}}</div>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
        <div class="mg-side10">
            <div class="flex justify-content-between filter-title-block">
                <span class="filter-title">Date</span>
            </div>
            <div class="flex flex-column mrgbtm-10">
                <label for="dateformat" class="filter-label">Start date</label>
                <p-calendar [(ngModel)]="startDate" dateFormat="mm-dd-yy" inputId="dateformat"></p-calendar>
            </div>
            <div class="flex flex-column mrgbtm-10">
                <label for="dateformat" class="filter-label">End date</label>
                <p-calendar [(ngModel)]="endDate" dateFormat="mm-dd-yy" inputId="dateformat"></p-calendar>
            </div>
        </div>
    </p-scrollPanel>

    <hr class="hr-filter"/>

    <div class="flex justify-content-end mrg-10-0px">
        <button class="btn-darkblue" pButton label="Apply filter" (click)="clickFilter()"></button>
    </div>
</div>
